if (!customElements.get('locally-widget')) {
  customElements.define(
    'locally-widget',
    class LocallyWidget extends HTMLElement {
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, this.onVariantChange.bind(this));
      }

      disconnectedCallback() {
        this.variantChangeUnsubscriber?.();
      }

      get embed() {
        return document.getElementById(`lcly-embed-${this.dataset.sectionId}`);
      }

      // Liquid renders this payload and product-info refreshes it via
      // updateSourceFromDestination('lcly-upc') before publishing variantChange,
      // so it always describes the variant that was just selected.
      get payload() {
        try {
          return JSON.parse(this.querySelector('script[type="application/json"]')?.textContent ?? '');
        } catch (error) {
          return null;
        }
      }

      onVariantChange({ data: { sectionId } }) {
        if (sectionId !== this.dataset.sectionId) return;

        const payload = this.payload;
        const embed = this.embed;
        if (!payload || !embed) return;

        // Unhide before reloading: Locally measures layout, and a reload into
        // display:none renders a zero-size widget.
        const hide = payload.hidden === true;
        embed.classList.toggle('hidden', hide);
        if (hide) return;

        if (typeof window.lcly_reload_0 !== 'function') return;
        window.lcly_reload_0(payload.barcode);
      }
    },
  );
}
